import Column from '../core/components/box/column';
import { ReactComponent as KlabLogo } from '../../assets/logos/klabLogo.svg';
import SizedBox from '../core/components/box/sizedBox';
import Row from '../core/components/box/row';
import useSiderController from '../../1_application/sider/siderController';
import { Divider, Menu } from 'antd';
import LXSelector from '../core/components/buttons/lxSelector';
import LanguageToggle from './components/languageToggle';
import { useTheme } from 'styled-components';
import { ReactComponent as Down } from '../../assets/icons/arrowDown.svg';
import useUser from '../../1_application/user/userController';
import { LXCaption, LXh5 } from '../core/texts/lxText';
import { Link, useNavigate } from 'react-router-dom';
import FlexBox from '../core/components/box/flexBox';
import LXIcon from '../core/components/buttons/lxIcon';
import { ReactComponent as Bell } from '../../assets/icons/notification.svg';
import useNewNotification from '../../1_application/sider/newNotificationController';
import { useEffect } from 'react';

const FivteenMinutes = 15 * 60 * 1000;

const LXSider = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { newNotificaiton, checkNewNotification } = useNewNotification();
  const m = useSiderController();
  const { signOut } = useUser();

  const userSummarySelectValues = [
    theme.texts.changePassword,
    theme.texts.support,
    theme.texts.signOut,
  ];

  const onSelect = (val: string) => {
    if (val === theme.texts.changePassword) {
      navigate('/clinic/changePassword');
    } else if (val === theme.texts.support) {
      navigate('/clinic/support');
    } else if (val === theme.texts.signOut) {
      signOut();
    } else {
      // eslint-disable-next-line no-throw-literal
      throw 'invalid button value';
    }
  };

  useEffect(() => {
    checkNewNotification();
    const interval = setInterval(() => {
      checkNewNotification();
    }, FivteenMinutes);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column
      width="240px"
      padding="40px 30px 30px 30px"
      height="100vh"
      alignItems="center"
      flexShrink={0}
    >
      <Link to={'/clinic/dashboard'}>
        <KlabLogo width={130} height={48}></KlabLogo>
      </Link>
      <SizedBox height={60}></SizedBox>
      <LXSelector<string>
        kind="custom"
        customHeader={<UserSummary></UserSummary>}
        dropdownItemWidth={180}
        labels={userSummarySelectValues}
        values={userSummarySelectValues}
        onSelect={onSelect}
      ></LXSelector>
      <SizedBox height={16}></SizedBox>
      <Divider style={{ margin: 0 }}></Divider>
      <SizedBox height={60}></SizedBox>
      <Menu
        inlineIndent={0}
        defaultOpenKeys={m.openKeys}
        selectedKeys={m.selectedKeys}
        mode="inline"
        openKeys={m.openKeys}
        onOpenChange={m.onOpenChange}
        items={m.menuItems}
        onSelect={m.onSelect}
      />
      <FlexBox></FlexBox>
      <Row width="100%" justifyContent="space-between" alignItems="center">
        <LanguageToggle></LanguageToggle>
        <Link to="/clinic/notification">
          <LXIcon
            newAlarm={newNotificaiton}
            width="48px"
            backgroundColor={theme.colors.grayBgLight}
            icon={Bell}
          ></LXIcon>
        </Link>
      </Row>
    </Column>
  );
};

const UserSummary = () => {
  const { user } = useUser();
  const [emailFirst, emailSecond] = user.email.split('@');

  return (
    <Row width="100%" cursor="pointer">
      <SizedBox width={10}></SizedBox>
      <Column width="146px">
        <LXh5>{emailFirst}</LXh5>
        <LXCaption>{emailSecond}</LXCaption>
      </Column>
      <Down></Down>
    </Row>
  );
};

export default LXSider;
